import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkCustomerDecline = hashCodeCertificate("WaybillV2BulkCustomerDecline")
export default WaybillV2BulkCustomerDecline